<fieldset>
  <legend *ngIf="!isMilesMobileRedirect" class="sr-only">
    {{ content?.searchoptionLabel }}
  </legend>
  <div
    [formGroup]="bookWidgetForm"
    class="row booking-widget_search-checkbox-section"
  >
    <div
      *ngIf="!isMilesMobileRedirect"
      class="d-none d-lg-block col-lg-2 searchOptionLabel"
    >
      {{ content?.searchoptionLabel }}
    </div>
    ​
    <div
      *ngIf="content?.toggleMiles && content?.milesLabel"
      [ngClass]="{
        disableSearchText:
          restrictMiles ||
          corpPartner.disableMiles ||
          disabledByEdocData?.disableShowPriceIn
            ? true
            : false
      }"
      class="col-sm-auto col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn modify-checkbox searchOptionActive d-flex"
    >
      <a
        #showpriceinHelp="ngcHelpModalDirective"
        (click)="showpriceinHelp?.openHelpModal()"
        [helpContent]="content?.tooltips?.get('show-price-in')"
        [type]="'showpricein'"
        aria-haspopup="true"
        class="icon-help booking-help circle-outline searchOptionHelpIcon order-2"
        draggable="false"
        href="javascript:void(0);"
        ngc-help-modal-directive
      >
        <span class="sr-only">{{ content?.milesLabel }} help</span>
      </a>
      <input
        (change)="shopWithMilesClicked($event)"
        [attr.disabled]="
          restrictMiles ||
          corpPartner.disableMiles ||
          disabledByEdocData?.disableShowPriceIn
            ? true
            : null
        "
        [checked]="bookWidgetForm?.controls['schedulePrice']?.value === 'miles'"
        class="searchOptionChk order-1"
        id="shopWithMiles"
        name="shopWithMiles"
        type="checkbox"
      />
      <label
        [ngClass]="{
          disableSearchText:
            restrictMiles ||
            corpPartner.disableMiles ||
            disabledByEdocData?.disableShowPriceIn
              ? true
              : false
        }"
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="shopWithMiles"
      >
        {{ content?.milesLabel }}
      </label>
    </div>
    ​
    <div
      *ngIf="content?.toggleMiles && mpmTravel && content?.milesPlusMoneyLabel"
      class="col-sm-auto col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn modify-checkbox searchOptionActive d-flex"
    >
      <a
        #showpriceinHelp="ngcHelpModalDirective"
        (click)="showpriceinHelp?.openHelpModal()"
        *ngIf="content?.tooltips?.get('miles-plus-money')"
        [helpContent]="content?.tooltips?.get('miles-plus-money')"
        [type]="'showpricein'"
        aria-haspopup="true"
        class="icon-help booking-help circle-outline searchOptionHelpIcon order-2"
        draggable="false"
        href="javascript:void(0);"
        ngc-help-modal-directive
      >
        <span class="sr-only">{{ content?.milesPlusMoneyLabel }} help</span>
      </a>
      <input
        (change)="shopWithMoneyPlustMilesClicked($event)"
        (click)="redirectMilesPlusMoney($event)"
        [attr.disabled]="restrictmpmTravel ? true : null"
        [checked]="
          bookWidgetForm?.controls['schedulePrice']?.value === 'milesplusmoney'
        "
        class="searchOptionChk order-1"
        id="miles_plus_money"
        name="miles_plus_money"
        type="checkbox"
      />
      <label
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="miles_plus_money"
        id="milesPlusMoneyLabel"
      >
        <span class="sr-only">
          selecting Miles plus Money will open the login page
        </span>
        <span class="">{{ content?.milesPlusMoneyLabel }}</span>
      </label>
    </div>
    ​
    <div
      *ngIf="content?.refundableFareLabel"
      [ngClass]="{
        searchOptionDisable:
          (disabledByEdocData && disabledByEdocData.disableRefundableFares) ||
          !canBookNonRefundableValue ||
          awardTravel
      }"
      class="col-sm-auto col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn modify-checkbox searchOptionActive d-flex"
    >
      <a
        #refundablefaresHelp="ngcHelpModalDirective"
        (click)="refundablefaresHelp?.openHelpModal()"
        *ngIf="content?.tooltips?.get('refundable-fares')"
        [helpContent]="toolTipContent"
        [type]="'refundablefares'"
        aria-haspopup="true"
        class="icon-help booking-help circle-outline searchOptionHelpIcon order-2"
        draggable="false"
        href="javascript:void(0);"
        ngc-help-modal-directive
      >
        <span class="sr-only">{{ content?.refundableFareLabel }} help</span>
      </a>
      <input
        [attr.disabled]="
          disabledByEdocData?.disableRefundableFares ||
          !canBookNonRefundableValue ||
          awardTravel
            ? true
            : null
        "
        [checked]="canBookNonRefundableValue === false ? true : false"
        [formControlName]="'refundableFlightsOnly'"
        class="searchOptionChk order-1"
        id="refundableFlightsOnly"
        name="refundableFlightsOnly"
        type="checkbox"
      />
      <label
        [ngClass]="{
          disableSearchText:
            (disabledByEdocData && disabledByEdocData.disableRefundableFares) ||
            !canBookNonRefundableValue ||
            awardTravel
        }"
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="refundableFlightsOnly"
      >
        {{ content?.refundableFareLabel }}
      </label>
    </div>
    ​
    <div
      *ngIf="
        content?.flexibleDates &&
        selectTripType !== 'MULTICITY' &&
        !isMilesMobileRedirect
      "
      [ngClass]="{
        searchOptionDisable:
          isMilesMobileRedirect ||
          isFlexAirPort ||
          disabledByEdocData?.disableFlexibleDates === 'true'
      }"
      class="col-sm-auto col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn search-opt-flex-date modify-checkbox searchOptionActive"
    >
      <input
        (change)="flexiDatesClicked($event)"
        [attr.disabled]="
          isMilesMobileRedirect ||
          isFlexAirPort ||
          disabledByEdocData?.disableFlexibleDates === 'true'
            ? true
            : null
        "
        [formControlName]="'chkFlexDate'"
        class="searchOptionChk"
        id="chkFlexDate"
        name="chkFlexDate"
        type="checkbox"
      />
      <label
        [ngClass]="{
          disableSearchText:
            isMilesMobileRedirect ||
            isFlexAirPort ||
            disabledByEdocData?.disableFlexibleDates === 'true'
        }"
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="chkFlexDate"
      >
        {{ content?.flexibleDates }}
      </label>
    </div>
    <div
      *ngIf="
        flightPlusHotel && !restrictFlightHotel && !content.enableFlightPlusCar
      "
      class="col-sm-auto col-lg-3 col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn modify-checkbox searchOptionActive"
    >
      <input
        (change)="onFlightPlusHotelClicked($event)"
        [formControlName]="'flightHotelDeals'"
        class="searchOptionChk flightHotelDeals"
        id="flightHotelDeals"
        name="flightHotelDeals"
        type="checkbox"
      />
      <label
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="flightHotelDeals"
      >
        {{ content?.flightPlusHotelLabel }}
      </label>
      <span
        *ngIf="bookWidgetForm.get('flightHotelDeals')?.value === true"
        class="fph-disclaimer d-none d-lg-block"
        id="fph-disclaimer"
      >
        {{ flightHotelContent.disclaimer }}
      </span>
    </div>
    <div
      *ngIf="
        flightPlusHotel && !restrictFlightHotel && content.enableFlightPlusCar
      "
      class="col-sm-auto col-lg-3 col-md-6 checkbox-wrapper vs-flexCheckBox searchOptionCheckboxColumn modify-checkbox searchOptionActive"
    >
      <input
        (change)="onFlightPlusHotelClicked($event)"
        [formControlName]="'flightHotelDeals'"
        class="searchOptionChk flightHotelDeals"
        id="flightHotelDeals"
        name="flightHotelDeals"
        type="checkbox"
      />
      <label
        class="content icon-Checked booking-widget_checkbox-mobile searchOptionFilter"
        for="flightHotelDeals"
      >
        {{ content?.flightPlusCarLabel }}
      </label>
      <span
        *ngIf="bookWidgetForm.get('flightHotelDeals')?.value === true"
        class="fph-disclaimer d-none d-lg-block"
        id="fph-disclaimer"
      >
        {{ flightHotelContent.carDisclaimer }}
      </span>
    </div>
  </div>
</fieldset>
<div
  *ngIf="
    flightPlusHotel && !restrictFlightHotel && !content.enableFlightPlusCar
  "
  class="row disclaimer-row"
>
  <span
    *ngIf="bookWidgetForm.get('flightHotelDeals')?.value === true"
    class="col-12 d-block d-lg-none offset-lg-4 fph-disclaimer"
    id="fph-disclaimer"
  >
    {{ flightHotelContent.disclaimer }}
  </span>
</div>
